import styled from 'styled-components';

/** Fondo su cui appoggia il book: piu' scuro del bianco carta, cosi' le pagine si staccano. */
const DESK_BACKGROUND = '#e8eaed';
/** Fondo dello sheet di selezione: le miniature si leggono meglio su scuro. */
export const PICKER_BACKGROUND = '#14171a';
const PICKER_RAISED_BACKGROUND = '#1c2128';

const PAPER_SHADOW = '0 1px 2px rgba(20, 23, 26, 0.1), 0 5px 12px rgba(20, 23, 26, 0.07)';

export const MobileBookEditorWrapper = styled.div`
    --page-gutter: 2px;
    --spread-gap: 1.25rem;

    position: relative;
    min-height: 100%;
    background-color: ${DESK_BACKGROUND};

    .mobile-book-topbar {
        position: sticky;
        top: 0;
        z-index: 20;
        padding: 0.75rem 0.875rem 0.625rem;
        background-color: #fff;
        border-bottom: ${(props) => props.theme.DefaultBorder};

        .topbar-title {
            display: flex;
            align-items: center;
            gap: 0.5rem;

            h2 {
                flex: 1 1 auto;
                min-width: 0;
                margin: 0;
                font-size: 1rem;
                font-weight: 600;
                letter-spacing: -0.015em;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        .topbar-meta {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 0.625rem;
            margin-top: 0.5rem;

            .meta-counts {
                min-width: 0;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-family: ${(props) => props.theme.FontFamilyMonospace};
                font-size: 0.625rem;
                letter-spacing: 0.035em;
                text-transform: uppercase;
                color: ${(props) => props.theme.DisabledTextColor};
            }
        }
    }

    .mobile-book-canvas {
        padding: 1rem 0.875rem 1.5rem;
    }

    .book-spreads {
        display: flex;
        flex-direction: column;
        gap: var(--spread-gap);
    }

    .book-sequence {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    .book-spread {
        display: flex;
        gap: var(--page-gutter);

        .spread-slot {
            flex: 1 1 0;
            min-width: 0;
        }
    }

    .spread-folio {
        display: flex;
        justify-content: space-between;
        margin-top: 0.4rem;
        font-family: ${(props) => props.theme.FontFamilyMonospace};
        font-size: 0.625rem;
        letter-spacing: 0.09em;
        color: ${(props) => props.theme.DisabledTextColor};
    }

    .book-page {
        position: relative;
        width: 100%;
        aspect-ratio: 3 / 4;
        overflow: hidden;
        background-color: #fff;
        box-shadow: ${PAPER_SHADOW};

        img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
        }

        &.landscape {
            aspect-ratio: 3 / 2;
        }

        &.blank {
            box-shadow:
                inset 0 0 0 1px ${(props) => props.theme.DarkerBorderColor},
                0 1px 2px rgba(20, 23, 26, 0.06);

            .blank-mark {
                position: absolute;
                inset: 0.45rem;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0 0.25rem;
                border: 1px dashed ${(props) => props.theme.DarkerBorderColor};
                font-size: 0.5625rem;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                text-align: center;
                color: ${(props) => props.theme.DisabledTextColor};
            }

            &.blank-locked .blank-mark {
                border-style: solid;
                border-color: ${(props) => props.theme.LighterBorderColor};
            }
        }

        .page-hit {
            position: absolute;
            inset: 0;
            z-index: 2;
            border: 0;
            padding: 0;
            background-color: transparent;
            cursor: pointer;
            /* con l'attivazione a pressione prolungata di dnd-kit lo scroll resta libero */
            touch-action: manipulation;
        }

        .page-number {
            position: absolute;
            left: 0.5rem;
            bottom: 0.5rem;
            z-index: 3;
            pointer-events: none;
            padding: 0.2rem 0.4rem;
            border-radius: 3px;
            background-color: rgba(10, 13, 16, 0.72);
            color: #fff;
            font-family: ${(props) => props.theme.FontFamilyMonospace};
            font-size: 0.6875rem;
        }

        .page-video-mark {
            position: absolute;
            right: 0.5rem;
            top: 0.5rem;
            z-index: 3;
            pointer-events: none;
            width: 1.4rem;
            height: 1.4rem;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: rgba(10, 13, 16, 0.6);
            color: #fff;
            font-size: 0.6rem;
        }

        .page-actions {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 4;
            display: flex;
            gap: 1px;

            button {
                flex: 1 1 0;
                border: 0;
                padding: 0.55rem 0.15rem;
                background-color: rgba(14, 18, 22, 0.88);
                color: #fff;
                font-size: 0.625rem;
                font-weight: 500;
                letter-spacing: 0.04em;
                text-transform: uppercase;
                cursor: pointer;

                &.action-move {
                    background-color: ${(props) => props.theme.PrimaryColor};
                }

                &.action-remove {
                    background-color: ${(props) => props.theme.DangerColor};
                }
            }
        }

        &.dragging {
            opacity: 0.92;
            box-shadow:
                0 4px 10px rgba(20, 23, 26, 0.16),
                0 14px 30px rgba(20, 23, 26, 0.14);
        }

        &.in-hand {
            box-shadow: inset 0 0 0 2px ${(props) => props.theme.PrimaryColor};

            img {
                opacity: 0.4;
                filter: grayscale(1) contrast(0.65);
            }

            .in-hand-mark {
                position: absolute;
                left: 50%;
                top: 50%;
                z-index: 3;
                pointer-events: none;
                transform: translate(-50%, -50%);
                padding: 0.25rem 0.45rem;
                border-radius: 3px;
                white-space: nowrap;
                background-color: ${(props) => props.theme.PrimaryColor};
                color: #fff;
                font-family: ${(props) => props.theme.FontFamilyMonospace};
                font-size: 0.5625rem;
                letter-spacing: 0.1em;
                text-transform: uppercase;
            }
        }
    }

    .book-drop-rail {
        position: relative;
        z-index: 5;
        display: block;
        border: 0;
        padding: 0;
        background-color: transparent;
        cursor: pointer;

        i {
            position: absolute;
            display: block;
            border-radius: 99px;
            background-color: ${(props) => props.theme.PrimaryColor};
            opacity: 0.5;
        }

        &.horizontal {
            width: 100%;
            height: 1.625rem;
            /* altezza netta zero: il binario si sovrappone al gap tra le righe */
            margin: -0.8125rem 0;

            i {
                left: 0;
                right: 0;
                top: 0.6875rem;
                bottom: 0.6875rem;
            }
        }

        &.vertical {
            flex: 0 0 auto;
            align-self: stretch;
            width: 1.375rem;
            margin: 0 -0.6875rem;

            i {
                top: 0;
                bottom: 0;
                left: 0.5625rem;
                right: 0.5625rem;
            }
        }
    }

    .mobile-book-empty {
        padding: 3.5rem 1.5rem;
        text-align: center;

        h3 {
            margin: 0 0 0.35rem;
            font-size: 0.95rem;
            font-weight: 600;
        }

        p {
            margin: 0;
            font-size: 0.85rem;
            color: ${(props) => props.theme.TextColorMuted};
        }
    }

    .mobile-book-actionbar {
        position: sticky;
        bottom: 0;
        z-index: 20;
        display: flex;
        align-items: center;
        gap: 0.625rem;
        padding: 0.625rem 0.875rem;
        background-color: #fff;
        border-top: ${(props) => props.theme.DefaultBorder};

        .ant-btn {
            flex: 1 1 0;
        }
    }

    .mobile-book-movebar {
        position: sticky;
        bottom: 0;
        z-index: 20;
        display: flex;
        align-items: center;
        gap: 0.7rem;
        padding: 0.625rem 0.75rem;
        background-color: ${PICKER_BACKGROUND};
        color: #fff;

        .movebar-thumb {
            flex: 0 0 auto;
            width: 2.15rem;
            height: 2.85rem;
            overflow: hidden;
            background-color: rgba(255, 255, 255, 0.12);

            img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .movebar-text {
            flex: 1 1 auto;
            min-width: 0;

            b {
                display: block;
                font-size: 0.8rem;
                font-weight: 600;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            span {
                display: block;
                margin-top: 0.1rem;
                font-family: ${(props) => props.theme.FontFamilyMonospace};
                font-size: 0.6rem;
                letter-spacing: 0.05em;
                text-transform: uppercase;
                color: rgba(255, 255, 255, 0.55);
            }
        }

        .movebar-cancel {
            flex: 0 0 auto;
            border: 1px solid rgba(255, 255, 255, 0.28);
            border-radius: 4px;
            padding: 0.5rem 0.8rem;
            background-color: transparent;
            color: #fff;
            font-size: 0.8rem;
            cursor: pointer;
        }
    }
`;

export const MobileMediaPickerWrapper = styled.div`
    min-height: 100%;
    background-color: ${PICKER_BACKGROUND};
    color: #fff;

    .picker-header {
        position: sticky;
        top: 0;
        z-index: 10;
        padding: 0.875rem 0.875rem 0;
        background-color: ${PICKER_BACKGROUND};

        .picker-header-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 0.6rem;

            h2 {
                margin: 0;
                font-size: 0.95rem;
                font-weight: 600;
                color: #fff;
            }
        }

        .picker-filters {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 0.6rem;
            padding: 0.8rem 0 0.75rem;
        }

        .ant-segmented {
            background-color: rgba(255, 255, 255, 0.1);
            color: rgba(255, 255, 255, 0.6);

            .ant-segmented-item-selected {
                background-color: #fff;
                color: ${PICKER_BACKGROUND};
            }

            .ant-segmented-thumb {
                background-color: #fff;
            }

            .ant-segmented-item:hover:not(.ant-segmented-item-selected) {
                color: #fff;
            }
        }
    }

    .picker-link {
        border: 0;
        padding: 0.35rem 0.15rem;
        background-color: transparent;
        color: rgba(255, 255, 255, 0.62);
        font-size: 0.8rem;
        cursor: pointer;

        &.accent {
            color: ${(props) => props.theme.PrimaryColor};
        }

        &:disabled {
            opacity: 0.35;
            cursor: default;
        }
    }

    .picker-used-toggle {
        flex: 0 0 auto;
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 99px;
        padding: 0.4rem 0.75rem;
        background-color: transparent;
        color: rgba(255, 255, 255, 0.66);
        font-size: 0.7rem;
        cursor: pointer;

        &[aria-pressed='true'] {
            background-color: ${(props) => props.theme.PrimaryColor};
            border-color: ${(props) => props.theme.PrimaryColor};
            color: #fff;
        }
    }

    .picker-grid {
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        gap: 0.375rem;
        padding: 0.25rem 0.875rem 1rem;
    }

    .picker-message {
        width: 100%;
        padding: 3rem 1rem;
        text-align: center;
        font-size: 0.85rem;
        color: rgba(255, 255, 255, 0.5);
    }

    .picker-thumb {
        position: relative;
        width: calc((100% - 0.75rem) / 3);
        aspect-ratio: 3 / 4;
        overflow: hidden;
        background-color: ${PICKER_RAISED_BACKGROUND};

        &.landscape {
            width: calc(((100% - 0.75rem) / 3) * 2 + 0.375rem);
            aspect-ratio: 3 / 2;
        }

        img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.2s;
        }

        .thumb-select {
            position: absolute;
            inset: 0;
            z-index: 2;
            border: 0;
            padding: 0;
            background-color: transparent;
            cursor: pointer;
        }

        &.selected {
            img {
                transform: scale(0.9);
            }

            .thumb-select {
                box-shadow: inset 0 0 0 3px ${(props) => props.theme.PrimaryColor};
            }
        }

        &.in-book {
            opacity: 0.3;

            .thumb-select {
                cursor: default;
            }
        }

        .thumb-order {
            position: absolute;
            top: 0.3rem;
            right: 0.3rem;
            z-index: 3;
            min-width: 1.25rem;
            height: 1.25rem;
            padding: 0 0.3rem;
            border-radius: 99px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: ${(props) => props.theme.PrimaryColor};
            color: #fff;
            font-family: ${(props) => props.theme.FontFamilyMonospace};
            font-size: 0.65rem;
            font-weight: 600;
        }

        .thumb-inbook {
            position: absolute;
            left: 0.3rem;
            bottom: 0.3rem;
            z-index: 3;
            padding: 0.15rem 0.3rem;
            background-color: rgba(0, 0, 0, 0.62);
            font-size: 0.5rem;
            letter-spacing: 0.08em;
            text-transform: uppercase;
        }

        .thumb-preview {
            position: absolute;
            right: 0.3rem;
            bottom: 0.3rem;
            z-index: 4;
            width: 1.5rem;
            height: 1.5rem;
            border: 0;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: rgba(0, 0, 0, 0.55);
            color: #fff;
            font-size: 0.6rem;
            cursor: pointer;
        }

        &.picker-blank {
            background-color: transparent;

            .blank-mark {
                position: absolute;
                inset: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0.35rem;
                border: 1px dashed rgba(255, 255, 255, 0.3);
                text-align: center;
                font-size: 0.5625rem;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                color: rgba(255, 255, 255, 0.55);
            }
        }
    }

    .picker-tray {
        position: sticky;
        bottom: 0;
        z-index: 10;
        padding: 0.625rem 0.875rem;
        background-color: ${PICKER_RAISED_BACKGROUND};
        border-top: 1px solid rgba(255, 255, 255, 0.09);

        .tray-strip {
            display: flex;
            gap: 0.3rem;
            overflow-x: auto;
            padding-bottom: 0.6rem;
        }

        .tray-chip {
            position: relative;
            flex: 0 0 auto;
            width: 2.15rem;
            height: 2.85rem;
            border: 0;
            padding: 0;
            overflow: hidden;
            background-color: rgba(255, 255, 255, 0.1);
            cursor: pointer;

            img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }

            .chip-remove {
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                height: 0.95rem;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: rgba(10, 13, 16, 0.78);
                color: #fff;
                font-size: 0.55rem;
            }
        }

        .tray-hint {
            padding: 0.6rem 0 0.75rem;
            font-family: ${(props) => props.theme.FontFamilyMonospace};
            font-size: 0.625rem;
            letter-spacing: 0.04em;
            text-transform: uppercase;
            color: rgba(255, 255, 255, 0.42);
        }

        .ant-btn {
            width: 100%;
        }
    }
`;
